/** 記事タイトルをAPIへ送れる最大文字数。SDKのDOM読み取りでも同じ値を使う。 */
export const PAGE_TITLE_MAX_LENGTH = 300;

/** 記事概要をAPIへ送れる最大文字数。SDKのDOM読み取りでも同じ値を使う。 */
export const PAGE_DESCRIPTION_MAX_LENGTH = 2000;
